<template>
    <span class="text-primary" v-if="permiteEnviarParaAnalise">
        <i
            class="fa fa-paper-plane fa-lg icon-button mr-1"
            title="Enviar para análise"
            @click.stop="confirmarEnviarParaAnalise()"
        ></i>
    </span>
</template>

<script>
import { comprometimentoStatus } from './ComprometimentoStatus'

export default {
    props: {
        contratoTipoEspecial: {
            type: Boolean,
            default: () => false
        },

        comprometimento: {
            type: Object,
            default: () => ({})
        },

        anexo: {
            type: Object,
            default: () => ({})
        },

        dataServico: {
            type: Object,
            required: true,
            default: () => ({})
        }
    },

    data() {
        return {}
    },

    methods: {
        confirmarEnviarParaAnalise() {
            let mensagem
            if (this.comprometimentoForaDoPrazo) {
                mensagem = `Confirma o envio do serviço <b>${this.comprometimento.idComprometimento}</b> para análise?
                <br/><br/><div class="alert alert-danger" role="alert">
                <div class="row">
                            <div class="col-3">
                                <i class="fa fa-exclamation-circle fa-5x"></i>
                            </div>
                            <div class="col-9">
                                <h4>Atenção!!! O mês/ano previsto para esse serviço é posterior ao atual. 
                                Confirma o envio para análise?</h4>
                            </div>
                        </div>
		             </div>`
            } else {
                mensagem = `Confirma o envio do serviço <b>${this.comprometimento.idComprometimento}</b> para análise?`
            }
            this.$swal({
                title: 'Envio para análise',
                html: mensagem,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then((result) => {
                if (result.value) {
                    this.enviarParaAnalise()
                }
            })
        },

        enviarParaAnalise() {
            this.$store.dispatch('addRequest')
            this.dataServico
                .enviarComprometimentoParaAnalise(
                    this.comprometimento.idComprometimento
                )
                .then((response) => {
                    if (response) {
                        if (response.success) {
                            this.$toast.success(
                                'Serviço enviado com sucesso!',
                                'OK',
                                this.$toastConfig.success
                            )
                            this.$emit('obter-atualizacao')
                        } else {
                            this.$toast.error(
                                'Erro ao enviar serviço para análise. ' +
                                    response.errors[0],
                                'ERROR',
                                this.$toastConfig.error
                            )
                        }
                    }
                    this.$store.dispatch('removeRequest')
                })
        }
    },

    computed: {
        permiteEnviarParaAnalise() {
            let anexosOk = true
            if (this.contratoTipoEspecial) {
                anexosOk = this.comprometimento.qtdAnexos > 0
            }
            return (
                (this.comprometimento.status ==
                    comprometimentoStatus.EM_ABERTO ||
                    this.comprometimento.status ==
                        comprometimentoStatus.REPROVADA) &&
                this.$temAcessoView('CONT-COMPR-12') &&
                anexosOk
            )
        },

        comprometimentoForaDoPrazo() {
            if (this.comprometimento.dataMovimento) {
                return this.$moment(this.comprometimento.dataMovimento).isAfter(
                    new Date(),
                    'month'
                )
            }
            return false
        }
    }
}
</script>
